import { render, staticRenderFns } from "./BoothSelector.vue?vue&type=template&id=24a4d41c"
import script from "./BoothSelector.vue?vue&type=script&lang=ts"
export * from "./BoothSelector.vue?vue&type=script&lang=ts"
import style0 from "./BoothSelector.vue?vue&type=style&index=0&id=24a4d41c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports